// src/components/AppLayout.js
import React from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

const { Content } = Layout;

const AppLayout = ({ children }) => {
  const location = useLocation();
  
  // Páginas que no necesitan sidebar (como login)
  const noSidebarPages = ['/login'];
  const shouldShowSidebar = !noSidebarPages.includes(location.pathname);

  if (!shouldShowSidebar) {
    return <>{children}</>;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar />
      <Layout 
        className="main-content-layout"
        style={{ 
          marginLeft: 280,
          transition: 'margin-left 0.2s'
        }}
      >
        <Content style={{ overflow: 'auto' }}>
          {children}
        </Content>
      </Layout>
      
      {/* Estilos responsive */}
      <style jsx="true">{`
        @media (max-width: 768px) {
          .main-content-layout {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </Layout>
  );
};

export default AppLayout;